module.exports = __webpack_public_path__ + "img/button_get.2c12ec3b.png";